import { render, staticRenderFns } from "./chatDataList.vue?vue&type=template&id=38415118&scoped=true&"
import script from "./chatDataList.vue?vue&type=script&lang=js&"
export * from "./chatDataList.vue?vue&type=script&lang=js&"
import style0 from "./chatDataList.vue?vue&type=style&index=0&id=38415118&scoped=true&lang=css&"
import style1 from "./chatDataList.vue?vue&type=style&index=1&id=38415118&scoped=true&lang=less&"
import style2 from "./chatDataList.vue?vue&type=style&index=2&id=38415118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38415118",
  null
  
)

export default component.exports